var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.70515 22C4.66449 22 4.62387 21.9879 4.58936 21.9638C4.52296 21.9173 4.49347 21.8359 4.51533 21.7597L6.80909 13.765L0.0742513 8.59573C0.0100092 8.54645 -0.0157369 8.46392 0.00966461 8.3887C0.0350661 8.31347 0.1062 8.2613 0.188213 8.25778L8.79208 7.89067L11.8147 0.123132C11.8435 0.049044 11.917 0 11.9991 0C12.0811 0 12.1547 0.0490439 12.1835 0.123084L15.2079 7.89067L23.8118 8.25778C23.8938 8.2613 23.965 8.31347 23.9903 8.3887C24.0157 8.46392 23.99 8.54645 23.9257 8.59573L17.1909 13.7651L19.4831 21.7597C19.505 21.8359 19.4755 21.9172 19.4091 21.9638C19.3426 22.0102 19.2533 22.0122 19.1848 21.9686L11.9991 17.3964L4.81365 21.9686C4.78066 21.9896 4.74291 22 4.70515 22Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.d0b709fac7f0faeabe9c9b3df08caf3d.svg";
export { ForwardRef as ReactComponent };